<template>
  <v-layout column fill-height align-start justify-start :class="nodes.length ? '' : 'pl-5'" >
    <scroll-area>
      <template slot="body">
        <v-treeview
          v-show="showTree"
          disable-resize-watcher="true"
          style="cursor: pointer; width: 100%"
          :open-all="true"
          :items="getTree"
          :active.sync="treeActive"
          :open="nodes.length ? getTree : opened"
          loading-icon="autorenew"
          :load-children="nodes.length ? null : loadChildren"
          expand-icon="expand_more"
          active-class="active"
          class="caption font-weight-medium font-condensend"
          item-disabled="disabled"
          activatable
          item-key="$id"
          return-object
        >
          <template v-slot:label="{ item, open, active }">
            <v-layout class="treeLeaf" @contextmenu.prevent="" fill-height align-center px-0>
                <v-icon small :color="$getColor($store.state.monitoring.status[item.$id])">brightness_1</v-icon>
                <svg-icon
                  color="blackLine"
                  :name="$checkItem(item)"
                  width="34"
                />
                <span light class="caption font-weight-medium font-condensend px-2">{{
                  item.name
                }}</span>
                <v-layout fill-height v-if="mode == 'service'" align-center justify-start class="caption">
                  <v-tooltip v-if="getApproveCls.includes(item.cls) && active" bottom color="secondary">
                    <v-btn :data-testid="$options.name + 'v-btn' + 'chooseDevice-item'" flat small outline @click.stop="() => chooseDevice(item)"  class="primary--text font-weight-medium" slot="activator" >
                      {{ $t('choose') }}
                    </v-btn>
                    <span v-if="getApproveCls.includes(item.cls) && active">{{ $t('add') }}</span>
                  </v-tooltip>
                  <!-- <v-tooltip v-if="(item.cls == 'device' || item.cls == 'module') && active" bottom color="secondary">
                    <v-btn :data-testid="$options.name + 'v-btn' + 'chooseDevice-item'" flat small outline @click.stop="() => chooseDevice(item)"  class="primary--text font-weight-medium" slot="activator" >
                      {{ $t('choose') }}
                    </v-btn>
                    <span v-if="(item.cls == 'device' || item.cls == 'module') && active">{{ $t('add') }}</span>
                  </v-tooltip>
                  <span v-if="mode == 'service' && item.tags && item.tags.length" light class="red--text subheading font-weight-medium font-condensend px-2">
                    {{ $t('involved in') }}: {{item.tags}}
                  </span> -->
                </v-layout>
              </v-layout>
          </template>
        </v-treeview>
      </template>
    </scroll-area>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import { CCMDBObject } from '@entcor/ebridge'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface TreeNode {
  $id?: string
  cls?: string
  children?: TreeNode[]
  disabled?: boolean
  name?: string
  slot_size?: number
  [key: string]: any
}

interface ExceptionsMap {
  [key: string]: string[]
}

interface StatusesMap {
  [key: string]: string
}

interface EquipmentData {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'EQUIPMENT_TREE_C',

  components: {
    scrollArea,
    svgIcon
  },

  props: {
    nodes: {
      type: Array as () => TreeNode[],
      default: () => []
    },
    data: {
      type: Object as () => EquipmentData,
      default: () => ({})
    },
    mode: {
      type: String,
      default: () => 'inventory'
    },
    expandAll: {
      type: Boolean,
      default: () => true
    },
    showStatuses: {
      type: Boolean,
      default: () => true
    },
    subscribe: {
      type: Boolean,
      default: () => true
    },
    treeshow: {
      type: Boolean,
      default: () => true
    },
    hideClass: {
      type: Array as () => string[],
      default: () => []
    },
    approveCls: {
      type: Array as () => string[],
      default: () => []
    },
  },

  data(): {
    currentActive: TreeNode | null
    selected: TreeNode[]
    opened: TreeNode[]
    selectedObj: any | null
    statuses: StatusesMap
    showTree: boolean
    includes: string[]
    exceptions: ExceptionsMap
    tree: TreeNode[]
  } {
    return {
      currentActive: null,
      selected: [],
      opened: [],
      selectedObj: null,
      statuses: {},
      showTree: false,
      includes: ['location', 'cabinet', 'device', 'slot', 'module', 'port'],
      exceptions: {
        device: [],
        module: [],
        location: [],
      },
      tree: [],
    }
  },

  watch: {
    selected: {
      handler(newVal: TreeNode[]): void {
        console.log('WATCH', this.$options.name, 'selected', 'newVal', newVal)
        if (newVal?.length) {
          this.$emit('selected', newVal[0])
        } else {
          this.$emit('selected', null)
        }
      },
      deep: true
    },
    nodes: {
      handler(newVal: TreeNode[]): void {
        console.log('WATCH', this.$options.name, 'nodes', 'newVal', newVal)
        if (newVal?.length) {
          this.selected = [newVal[0]]
          this.setup()
        }
      },
      deep: true
    },
  },

  computed: {
    getData(): EquipmentData {
      return this.data
    },

    getNodes(): TreeNode[] {
      const n$: TreeNode[] = []
      if (!this.nodes?.length) return []
      
      this.nodes.forEach(node => {
        const n = new CCMDBObject({ ...node })
        if (n.hasOwnProperty('children') && n.cls === 'port') {
          delete n.children
        }
        n$.push(node)
      })
      return n$
    },

    getApproveCls(): string[] {
      return this.approveCls
    },

    getTree(): TreeNode[] {
      const filter = (
        arr: TreeNode[] | undefined,
        inc: string[],
        exc: ExceptionsMap,
        parentCls?: string
      ): TreeNode[] => {
        return (arr || [])
          .map((n$, i) => {
            const n = new CCMDBObject({ ...n$ })
            
            if (this.getData?.$id && n.$id === this.getData.$id) {
              return false as unknown as TreeNode
            }
            if (n.cls === 'location') {
              n.disabled = true
            }
            if (n.children?.length !== n$.children?.length) {
              this.$set(n, 'children', n$.children)
            }
            if (n.cls === 'port' && n.hasOwnProperty('children')) {
              delete n.children
            }
            if (n.hasOwnProperty('children') && !n.children?.length && this.nodes.length) {
              delete n.children
            }
            if (!n.children?.length) {
              return n
            } else {
              n.children = filter(n.children, inc, exc, n.cls)
              return n
            }
          })
          .filter((n): n is TreeNode => {
            if (n && n.cls && inc.includes(n.cls) && !this.hideClass.includes(n.cls)) {
              if (Object.keys(exc).includes(n.cls)) {
                return !exc[n.cls].find(field => !n[field])
              }
              return true
            }
            return false
          })
      }
      
      if(this.nodes.length) {
        return filter(this.nodes, this.includes, this.exceptions)
      }
      else {
        return filter(this.tree, this.includes, this.exceptions)
      }
      
      // return filter(this.nodes, this.includes, this.exceptions)
      // return this.tree
    },

    treeActive: {
      get(): TreeNode[] {
        return this.selected
      },
      set(newVal: TreeNode[]): void {
        console.log(this.$options.name, 'treeActive', 'set', newVal)
        if (!newVal?.length) {
          if (this.currentActive?.$id) {
            this.$nextTick(() => {
              this.selected = [this.currentActive as TreeNode]
            })
          }
          return
        }
        if (Array.isArray(newVal) && newVal.length) {
          if (newVal[0].$id === this.currentActive?.$id) {
            return
          }
          if (!this.currentActive) {
            this.currentActive = newVal[0]
          }
        }
        this.selected = newVal
        this.currentActive = newVal[0]
      },
    },
  },

  created(): void {
    this.setup()
  },

  beforeDestroy(): void {
    if (this.subscribe) {
      this.statusUnsubscribe(this.$options.name || 'EQUIPMENT_TREE_C')
    }
  },

  methods: {
    async setup(): Promise<void> {
      console.log(this.$options.name, 'setup')
      console.log(this.$options.name, 'setup', 'this.getNodes', this.getNodes)

      if (!this.getNodes.length) {
        await this.loadTree()
      }
      if (this.subscribe) {
        console.log(this.$options.name, 'setup', 'this.nodes', this.nodes)
        this.statusUnsubscribe(this.$options.name || 'EQUIPMENT_TREE_C')
        this.statusSubscribe(this.getNodes, 'EQUIPMENT_TREE')
      }
      this.$nextTick(() => {
        this.showTree = true
      })
    },

    async loadTree(): Promise<void> {
      const query = {
        id: ['/physical'],
        data: {
          namePath: true,
          children: {
            data: {
              children: true,
              namePath: true,
              tags: true,
            },
            filter: { cls: { nin: ['folder'] } },
            tags: true,
          },
        }
      }
      
      const co = await this.$bridge.cmdbQuery(query)
      if (co) {
        const cycle = async (arr: TreeNode[]): Promise<TreeNode[]> => {
          arr.forEach(item => {
            if (item.cls === 'folder') {
              return
            }
            this.$bridge.subscribe([item.$id])
            if (item.children?.length === 0) {
              delete item.children
            }
            if (item.children?.length) {
              item.children = []
            }
          })
          return arr
        }
        this.tree = await cycle(co[0].children)
        console.log(this.$options.name, 'loadTree', 'this.tree', this.tree)
      }
    },

    async loadChildren(item: TreeNode): Promise<void> {
      console.log(this.$options.name, 'loadChildren', item)
      
      const query = {
        id: [item.$id],
        notNull: true,
        data: {
          namePath: true,
          children: {
            data: {
              children: true,
              namePath: true,
            },
            filter: { cls: { nin: ['folder'] } }
          },
        }
      }
      
      const co = await this.$bridge.cmdbQuery(query)
      console.log(this.$options.name, 'loadChildren co$', co)
      
      if (co) {
        const cycle = async (arr: TreeNode[]): Promise<TreeNode[]> => {
          arr.forEach(item => {
            this.$bridge.subscribe([item.$id])
            if (item.hasOwnProperty('children') && !item.children?.length) {
              delete item.children
            }
            if (item.children?.length) {
              item.children = []
            }
          })
          return arr
        }
        
        const children = await cycle(co[0].children)
        
        const updateTree = async (arr: TreeNode[]): Promise<void> => {
          arr.forEach((item_, i) => {
            if (item_.$id === item.$id) {
              if (children.length) {
                this.$set(item, 'children', children)
              } else {
                delete item.children
              }
              this.$set(arr, i, item)
              return
            }
            if (item_.children) {
              updateTree(item_.children)
            }
          })
        }
        
        await updateTree(this.tree)
      }
    },

    makeHeap(arr: TreeNode[]): TreeNode[] {
      const result: TreeNode[] = []
      const mapChildren = (arr_: TreeNode[]) => {
        arr_.forEach(item => {
          result.push(item)
          if (item.children?.length) {
            mapChildren(item.children)
          }
        })
      }
      mapChildren(arr)
      return result
    },

    async statusSubscribe(arr: TreeNode[], group: string): Promise<void> {
      if (!arr?.length) return
      
      const heap = this.makeHeap(arr)
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
      
      if (heap.length) {
        heap.forEach(item => {
          // console.log(this.$options.name, 'heap', 'item', item)
          if(item.$id == "port$8121") {
            console.log(this.$options.name, 'heap', 'item port$8121', item)
          }
        })
        await this.$bridge.subscribe(heap.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        if(e.$id == "port$8121") {
          console.log(this.$options.name, 'subscribeHandler port$8121', 'e', e)
        }
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    chooseDevice(val: TreeNode): void {
      console.log('chooseDevice', val)
      this.$emit('add', val)
    },
  },
})
</script>

<style lang="css" scoped>
.activeElement {
  border-radius: 14px;
}

.treeLeaf {
  height: 38px;
}

</style>
